/*=============================================== DemoPageLoading ===============================================*/

import { PageLoading } from "tsx-library-julseb"

import { DefaultLayout } from "components"

const DemoPageLoading = () => {
    return (
        <DefaultLayout title="Demo page loading">
            <PageLoading />
        </DefaultLayout>
    )
}

export default DemoPageLoading
